module.exports = __webpack_public_path__ + "static/media/matilde-hat-sri-lanka-scary.3453b59f.png";